import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import type { NextPage } from 'next';
import styles from './index.module.scss';

import { PageLayout } from '@/components/pagelay';
import { Checkbox, Form, Input, Modal, Radio, RadioGroup } from '@douyinfe/semi-ui';
import { Notification } from '@douyinfe/semi-ui';
import axios from 'axios';
import { Router, useRouter } from 'next/router';
import { IndexContext } from "@/stores";
import classNames from 'classnames';
import { PRODDOMAIN } from '@/utils';
import { toArray } from 'lodash';
import { getServerSideProps, getHead } from '@/utils/useHead';


interface IProps {
}
export { getServerSideProps }

const Apply: NextPage<IProps> = ({ navDetail }: any) => {
  const router = useRouter() as any
  const [prodCate, setProdCate] = useState([])
  const [country, setCountry] = useState([])
  const [region, setRegion] = useState([])
  const [city, setCity] = useState([])
  const [visible, setVisible] = useState(false)
  const [verify, setVerify] = useState()
  const [reload, setReload] = useState<any>()
  const [cookie, setCookie] = useState('')
  const formRef = useRef<any>()
  // const checkbox = useRef<any>()
  const { setIsHeadFoot } = useContext(IndexContext);


  const btnClick = useCallback(() => {
    // console.log('check', checkbox.current, formRef.current.getFormState().values);
    console.log(formRef.current.getFormState().values);
    // if (!checkbox.current) {
    //   Notification.open({
    //     content: '请先同意《数据保护条例-展商》',
    //     duration: 3,
    //   })
    //   return
    // }
    if (!verify) {
      Notification.open({
        content: 'Please enter Security code',
        duration: 3,
      })
      return
    }
    formRef.current.validate().then(async () => {
      const { data } = await axios.post('/api/exhibitor_apply', {
        lang: 'cn',
        captcha: verify,
        cookie,
        ...formRef.current.getFormState().values
      })
      if (data.code == 1) {
        Notification.open({
          content: "Success",
          duration: 3,
        })
        formRef.current.reset()
        window.location.href = 'https://bj.infosalons.com.cn/VSCENTER2/exhibitor/CBCE24/login'
        return;
      } else {
        getVerify()
        Notification.open({
          content: data.msg,
          duration: 3,
        })
      }

    }).catch((err: any) => {
      console.log(err, 'err');

      Notification.open({
        content: 'Please fill in the complete information',
        duration: 3,
      })
    })

  }, [verify, cookie])

  const transOption = useCallback((arr: any = []) => {
    return arr?.map((item: any) => {
      return {
        ...item,
        key: item.id,
        value: item.id,
        label: item.name_en
      }
    })
  }, [])


  const initTree = (list: any) => {
    return list.map((item: any) => {

      return {
        children:
          item.childlist && item.childlist.length > 0 ? initTree(item.childlist) : [],
        value: item.id,
        label: item.name_en,
        key: item.id,
      };
    });
  };

  const getRegion = useCallback(async (pid: any) => {
    const { data } = await axios.get(`/api/get_region`, {
      params: {
        pid
      }
    })
    const arr = transOption(toArray(data?.data))
    !!pid ? setCity(arr) : setRegion(arr)
  }, [])

  const getData = useCallback(async () => {
    getRegion(0)
    getVerify()
    const { data } = await axios.get(`/api/get_country`)
    setCountry(transOption(data?.data))
    const { data: _data } = await axios.get(`/api/product_category_list`)
    setProdCate(initTree(_data?.data))
  }, [])

  const arrayBufferToBase64 = useCallback((arrayBuffer: any) => {
    var binary = '';
    var bytes = new Uint8Array(arrayBuffer);
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }, [])

  const getVerify = useCallback(async () => {
    const { data } = await axios.get(`/api/get_verify`)
    setReload('data:image/png;base64,' + arrayBufferToBase64(data?.data?.img?.data))
    setCookie(data?.data?.cookie)
  }, [])

  const renderLabel = ({
    className,
    onExpand,
    data,
    onCheck,
    checkStatus,
    expandIcon,
  }: any) => {
    const { label } = data;
    const isLeaf = !(data.children && data.children.length);
    return (
      <li
        className={className}
        role="treeitem"
        onClick={isLeaf ? onCheck : onExpand}
      >
        {isLeaf ? null : expandIcon}
        {isLeaf ? <div onClick={onCheck} tabIndex={0} aria-checked={checkStatus.checked}>
        </div> : null}
        <span style={{ marginLeft: isLeaf ? '30px' : '' }}>{label}</span>
      </li>
    );
  };

  useEffect(() => {
    setIsHeadFoot(false)
    getData()
    return () => {
      setIsHeadFoot(true)
    }
  }, [])


  return (
    <div>
      <div className={styles.container}>
        {getHead(navDetail)}
        <div className={styles.content}>
          <img src="/image/en/apply-banner.png?v=2026" alt="" />
          <div className={styles.form}>
            <div className={styles.title}>
              <h2>Booth Application<span>Marked * are mandatory</span></h2>
              <div>
                <a href="/en">
                  <div className={styles.backBtn} style={{ backgroundColor: '#7a201e' }}>Return home</div>
                </a>
                <a href="https://cbce2025.gration.cn/?exhibitor/login&lang=en" target='_blank'>
                  <div className={styles.backBtn}>Registered,Return to log in</div>
                </a>
              </div>

            </div>
            <h2></h2>
            <Form
              getFormApi={(formApi: any) => formRef.current = formApi}
              labelPosition="left"
              labelWidth="155px"
              labelAlign="right"
            >
              {
                (({ formState, values, formApi }) => (
                  <div>
                    <h3><span>*</span>Booth Type</h3>
                    <div className={classNames([styles.type, 'type'])}>
                      <Form.RadioGroup
                        field="booth_type"
                        label={(<span></span>)}
                        direction='vertical'
                        rules={[
                          { required: true, message: 'Please choose booth type' },
                        ]}
                        onChange={() => {
                          console.log(formRef.current);
                          formRef.current.reset(['square1', 'square'])
                        }}
                      >
                        <Form.Radio value="1">
                          <div className={styles.radioRight}>
                            <div className={styles.label} style={{ paddingRight: '18px' }}>
                              <p>Raw Space</p>
                              <span>Min 18㎡</span>
                            </div>
                            <Form.InputNumber
                              className={styles.input}
                              field={formRef.current.getValue('booth_type') == '1' ? 'square' : 'square1'}
                              hideButtons
                              min={1}
                              disabled={formRef.current.getValue('booth_type') != '1'}
                              placeholder='Please enter the area'
                              label={(<span></span>)}
                              trigger='blur'
                              rules={[
                                { required: formRef.current.getValue('booth_type') == '1', message: 'Please enter the area' },
                              ]}
                            />
                          </div>
                        </Form.Radio>
                        <Form.Radio value="2">
                          <div className={styles.radioRight}>
                            <div className={styles.label}>
                              <p>Shell Scheme</p>
                              <span>Min 9㎡</span>
                            </div>
                            <Form.InputNumber
                              className={styles.input}
                              field={formRef.current.getValue('booth_type') == '2' ? 'square' : 'square1'}
                              hideButtons
                              min={1}
                              disabled={formRef.current.getValue('booth_type') != '2'}
                              placeholder='Please enter the area'
                              label={(<span></span>)}
                              trigger='blur'
                              rules={[
                                { required: formRef.current.getValue('booth_type') == '2', message: 'Please enter the area' },
                              ]}
                            />
                          </div>
                        </Form.Radio>
                      </Form.RadioGroup>
                    </div>
                    <h3>Company Information</h3>
                    <div className={styles.info}>
                      <Form.Input
                        className={styles.input}
                        field="company_cn"
                        placeholder='please enter the Company Name'
                        label={(<span className={styles.label}>Company Name</span>)}
                        trigger='blur'
                        rules={[
                          { required: true, message: 'please enter the Company Name' },
                          { validator: (rule, value) => !!value, message: '' }
                        ]}
                      />
                      <Form.Input
                        className={styles.input}
                        field="truename"
                        placeholder='please enter the name of Contact person'
                        label={(<span className={styles.label}>Contact person</span>)}
                        trigger='blur'
                        rules={[
                          { required: true, message: 'please enter the name of Contact person' },
                          { validator: (rule, value) => !!value, message: '' }
                        ]}
                      />
                      <Form.InputNumber
                        className={styles.input}
                        field="mobile"
                        hideButtons
                        placeholder='please enter your phone number'
                        label={(<span className={styles.label}>Mobile</span>)}
                        trigger='blur'
                        rules={[
                          { required: true, message: 'please enter your phone number' },
                          { validator: (rule, value) => !!value, message: '' }
                        ]}
                      />
                      <Form.RadioGroup
                        field="gender"
                        style={{ height: '56px' }}
                        label={(<span>Gender</span>)}
                        className='gender'
                      // initValue={'always'}
                      >
                        <Form.Radio value="1">
                          <span style={{ marginRight: '40px' }}>Mr</span>
                        </Form.Radio>
                        <Form.Radio value="2">
                          Mrs
                        </Form.Radio>
                      </Form.RadioGroup>

                      <Form.Input
                        className={styles.input}
                        field="position"
                        placeholder='please enter your position'
                        label={(<span className={styles.label}>Position</span>)}
                        trigger='blur'
                      />
                      <Form.Select
                        field="country_id"
                        label={(<span className={styles.label}>Country</span>)}
                        placeholder='please select your country'
                        onSelect={(value: any, option: any) => {
                          // console.log(value,option);
                          formRef.current.setValue('phone_code', '+' + option.code)
                          setVisible(value == 256)
                        }}
                        rules={[
                          { required: true, message: 'please select your country' },
                        ]}
                        optionList={country}
                      >
                      </Form.Select>
                      {visible && <Form.Slot label={{ text: 'Area', required: true }}>
                        <div className={classNames([styles.area, 'slot'])}>
                          <Form.Select
                            field="province_id"
                            label={(<></>)}
                            placeholder='Province'
                            rules={[
                              { required: true, message: 'Please select your province' },
                            ]}
                            optionList={region}
                            onSelect={(value: any, option: any) => {
                              getRegion(value)
                              formRef.current.reset(['city_id'])
                            }}
                          >
                          </Form.Select>
                          <Form.Select
                            field="city_id"
                            label={(<></>)}
                            placeholder='City'
                            rules={[
                              { required: true, message: 'Please select your city' },
                            ]}
                            optionList={city}
                            onSelect={(value: any, option: any) => {
                              formRef.current.setValue('phone_zone', option.area_code)
                            }}
                          >
                          </Form.Select>
                        </div>
                      </Form.Slot>}
                      <Form.Slot label={{ text: 'Tel' }}>
                        <div className={classNames([styles.phone, 'slot'])}>
                          <Form.Input
                            className={styles.input}
                            field="phone_code"
                            label={(<></>)}
                            readonly
                            initValue={'+86'}
                          />
                          <Form.Input
                            className={styles.input}
                            field="phone_zone"
                            placeholder='Area code'
                            label={(<></>)}
                          />
                          <Form.InputNumber
                            className={styles.input}
                            hideButtons
                            field="phone"
                            placeholder='Number'
                            label={(<></>)}
                          />
                        </div>
                      </Form.Slot>
                      <Form.Input
                        className={styles.input}
                        field="email"
                        placeholder='Please enter your email address'
                        label={(<span className={styles.label}>Email</span>)}
                        trigger='blur'
                        rules={[
                          { required: true, message: 'Please enter your email address' },
                          { validator: (rule, value) => !!value, message: '' }
                        ]}
                      />
                      <Form.Input
                        className={styles.input}
                        field="website"
                        placeholder='Please enter the company website'
                        label={(<span className={styles.label}>Company Website</span>)}
                      />
                      <div className={classNames([styles.twoCol, 'profile'])}>
                        <Form.Input
                          className={styles.input}
                          field="company_type"
                          placeholder='please enter the company type'
                          label={(<span className={styles.label}>Company Type</span>)}
                        />
                        <Form.TreeSelect
                          field="category_data"
                          labelWidth={110}
                          renderFullLabel={renderLabel}
                          dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                          treeData={prodCate}
                          placeholder="please choose"
                          disableStrictly
                          leafOnly
                          label={(<span className={classNames([styles.label])}>Exhibit of Profiles</span>)}
                          rules={[
                            { required: true, message: 'please choose' },
                          ]}
                        />
                      </div>
                    </div>
                  </div>
                ))
              }
            </Form>
            <div className={styles.vcode}>
              <input placeholder='Security code' value={verify} onChange={(e: any) => setVerify(e.target.value)}></input>
              {reload && <img src={reload} onClick={() => getVerify()} alt="" />}
            </div>
            {/* <div className={styles.allow}>
              <Checkbox onChange={(e) => checkbox.current = e.target.checked}>
                <p>我已阅读并同意</p>
              </Checkbox>
              <span>《数据保护条例-展商》</span>
            </div> */}
            <div className={styles.subBtn} onClick={btnClick}>Submit</div>
          </div>
        </div>
        <p>纽伦堡会展(上海)有限公司 版权所有 © 2025 沪ICP备09011147号-7</p>
      </div>

      <style jsx global lang='scss'>
        {
          `
          @media screen and (max-width: 887px) {
            .semi-form-field-label{
              text-align:left !important;
              padding-top: 0;
              width:100% !important;
            }
            .semi-form-field{
              flex-direction:column;
              padding-top: 0 !important;
            }
            .type .semi-form-field{
              padding-top:12px !important;
            }
          }
            .semi-form-field-label-required 
            .semi-form-field-label-text::before{
              content: "*";
              margin-right: 4px;
              color: var(--semi-color-danger);
              font-weight: 600;
            }
            .semi-form-field-label-text::after{
              display:none;
            }
            .semi-tree-option{
              padding:8px 12px !important;
            }
            .semi-form-field-label{
              font-weight:500;
              padding-right: 20px;
              margin-top:13px;
              font-size:16px;
              // display: flex;
              // align-items: center;
              // justify-content: right;
            }
            .profile> :last-child label{
              margin-top:0 !important;
            }
            .semi-input-wrapper,
            .semi-select,
            .semi-tree-select{
              width:100%;
              background:white !important;
              height: 56px;
              line-height: 56px;
              border: 1px solid #ddd;
              border-radius: 4px;
              &:hover{
                border: 1px solid #fcb814;
              }
            }
            .semi-form-field{
              padding: 0 0 20px;
              justify-content: flex-end;
            }
            .semi-radio-inner,
            .semi-radio-inner-display,
            .semi-checkbox-inner,
            .semi-checkbox-inner-display{
              width: 18px !important;
              height: 18px !important;
            }
            .semi-checkbox-checked .semi-checkbox-inner-display,
            .semi-radio-checked .semi-radio-inner-display{
              border: orange !important;
              background: orange !important;
              box-shadow: none;
            }
            .semi-icon-default{
              font-size:18px !important;
            } 
            .slot .semi-form-field-label{
              display: none !important;
            }
            .semi-form-slot{
              padding:0 !important;
            }
            .slot .semi-form-field{
              padding:0;
              padding:12px 0;
              // flex:1;
            }
            .gender .semi-radio{
              align-items:center;
              zoom:1.2;
            }
            .semi-input-number{
                width:100%;
              }
            .type{
              .semi-form-field-label{
                display: none !important;
              }
              .semi-radio-inner{
                transform: translateY(18px) !important;
              }
              
              .semi-radio-content,
              .semi-form-field{
                flex:1;
                // padding:0;
              }
              .semi-radioGroup-vertical{
                row-gap:0;
              }
            }
          `
        }
      </style>
    </div>
  );
};

export default Apply;
